import {useMemo} from "react";

import {useGetRcnDataQuery} from "../api/get_rcn_data_api";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {RcnStatsTarget} from "../types/RcnPriceStatsQuery";
import {getRcnHistoryQuery, RCN_HISTORY_GRAIN} from "../utils/get_rcn_params";

export interface IRcnHistoryPoint {
    /** The first day of the period, "2025-01-01" - where the point sits on the time axis. */
    date: string;
    value: number;
    transactions: number;
}

export interface IRcnHistory {
    points: IRcnHistoryPoint[];
    transactionsTotal: number;
    isLoading: boolean;
    isError: boolean;
}

/**
 * The address's published history in one grain - years by default, the only grain in which the registry publishes
 * every sale of a building (getRcnHistoryQuery). Market omitted (both markets combined, see get_rcn_params), so this
 * is one request, made with the very query the server prefetch makes: the page hydrates from its cache without a
 * request. RTK Query retries a failed request when a component subscribes again.
 */
export const useRcnHistory = (target: RcnStatsTarget | null | undefined, rooms: RoomsFilter, grain: RcnPriceStatsGrain = RCN_HISTORY_GRAIN): IRcnHistory => {
    const {currentData, isLoading, isFetching, isError} = useGetRcnDataQuery(getRcnHistoryQuery(target ?? 0, rooms, grain), {skip: !target});

    const points = useMemo(
        () =>
            (currentData?.series ?? [])
                .filter((point) => point.value > 0)
                .map((point): IRcnHistoryPoint => ({date: point.period_start, value: point.value, transactions: point.n_rows})),
        [currentData]
    );

    return {
        points,
        transactionsTotal: points.reduce((sum, point) => sum + point.transactions, 0),
        isLoading: isLoading || isFetching,
        isError
    };
};
import {useMemo} from "react";

import {useGetRcnDataQuery} from "../api/get_rcn_data_api";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {RcnStatsTarget} from "../types/RcnPriceStatsQuery";
import {getRcnHistoryQuery, RCN_HISTORY_GRAIN} from "../utils/get_rcn_params";

export interface IRcnHistoryPoint {
    /** The first day of the period, "2025-01-01" - where the point sits on the time axis. */
    date: string;
    value: number;
    transactions: number;
}

export interface IRcnHistory {
    points: IRcnHistoryPoint[];
    transactionsTotal: number;
    isLoading: boolean;
    isError: boolean;
}

/**
 * The address's published history in one grain - years by default, the only grain in which the registry publishes
 * every sale of a building (getRcnHistoryQuery). Market omitted (both markets combined, see get_rcn_params), so this
 * is one request, made with the very query the server prefetch makes: the page hydrates from its cache without a
 * request. RTK Query retries a failed request when a component subscribes again.
 */
export const useRcnHistory = (target: RcnStatsTarget | null | undefined, rooms: RoomsFilter, grain: RcnPriceStatsGrain = RCN_HISTORY_GRAIN): IRcnHistory => {
    const {currentData, isLoading, isFetching, isError} = useGetRcnDataQuery(getRcnHistoryQuery(target ?? 0, rooms, grain), {skip: !target});

    const points = useMemo(
        () =>
            (currentData?.series ?? [])
                .filter((point) => point.value > 0)
                .map((point): IRcnHistoryPoint => ({date: point.period_start, value: point.value, transactions: point.n_rows})),
        [currentData]
    );

    return {
        points,
        transactionsTotal: points.reduce((sum, point) => sum + point.transactions, 0),
        isLoading: isLoading || isFetching,
        isError
    };
};
